module.exports = __webpack_public_path__ + "img/select_all_icon.32b308d2.svg";